import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { SparkleStar } from '@peacecover/icon';
import { ReactComponent as GhostProfileIcon } from '../../../icons/thumbnail.ghost.profile.svg';

interface ThreadContentItemProps {
  speaker?: string;
  text: string;
  className?: string;
  hasLine?: boolean;
  showStar?: boolean;
}

const ThreadContentItem = ({
  speaker,
  text,
  className,
  hasLine = true,
  showStar = false
}: ThreadContentItemProps) => {
  const { t } = useTranslation();
  return (
    <div className={`px-[22px] py-[15px] flex gap-[10px] items-stretch ${className}`}>
      <div className="flex flex-col items-center gap-[8px]">
        <GhostProfileIcon width={26} height={26} />
        {hasLine && (
          <div className="w-[2px] flex-1 mb-[-20px] rounded-[16px] bg-[rgba(255,255,255,0.13)]" />
        )}
      </div>
      <div className="flex flex-col items-start gap-[5px] flex-1">
        <p className="text-[14px] font-semibold leading-[17px] text-separator-light-1">
          {speaker ?? t('SceneMain.anonymous')}
        </p>
        <p className="text-[15px] leading-[19px] text-pure-white relative">
          {text}
          {showStar && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
            >
              <SparkleStar
                size={11}
                className="absolute bottom-[3px] right-[-1px]"
                gradientStops={[
                  { offset: '-11%', color: '#45E0AD' },
                  { offset: '100%', color: '#5C3DFA' }
                ]}
              />
              <SparkleStar
                size={7}
                className="absolute bottom-[13px] right-[-8px]"
                gradientStops={[
                  { offset: '-11%', color: '#45E0AD' },
                  { offset: '100%', color: '#5C3DFA' }
                ]}
              />
            </motion.div>
          )}
        </p>
      </div>
    </div>
  );
};

export default ThreadContentItem;